/** Trendy per-course color themes for My Learning cards */

export const COURSE_THEMES = [
  { from: '#667eea', to: '#764ba2', accent: '#667eea', soft: '#667eea22' },
  { from: '#2563EB', to: '#1D4ED8', accent: '#2563EB', soft: '#2563EB22' },
  { from: '#10B981', to: '#0D9488', accent: '#10B981', soft: '#10B98122' },
  { from: '#8B5CF6', to: '#6D28D9', accent: '#8B5CF6', soft: '#8B5CF622' },
  { from: '#F59E0B', to: '#EA580C', accent: '#F59E0B', soft: '#F59E0B22' },
  { from: '#EC4899', to: '#DB2777', accent: '#EC4899', soft: '#EC489922' },
  { from: '#06B6D4', to: '#0891B2', accent: '#06B6D4', soft: '#06B6D422' },
  { from: '#EF4444', to: '#DC2626', accent: '#EF4444', soft: '#EF444422' },
  { from: '#6366F1', to: '#4F46E5', accent: '#6366F1', soft: '#6366F122' },
  { from: '#14B8A6', to: '#0F766E', accent: '#14B8A6', soft: '#14B8A622' },
];

const hashCourseCode = (code) => {
  let hash = 0;
  const value = String(code || '');
  for (let i = 0; i < value.length; i += 1) {
    hash = ((hash << 5) - hash) + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getCourseTheme = (courseCode) => {
  const index = hashCourseCode(courseCode) % COURSE_THEMES.length;
  return COURSE_THEMES[index];
};

export const formatCourseTitle = (name, code) => {
  const raw = String(name || code || '').trim();
  if (!raw) return 'Course';
  if (raw.includes('_')) {
    return raw
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }
  return raw;
};
